// extracted by mini-css-extract-plugin
export var fullHeightState = "_8-7";
export var headerCell = "_8-1";
export var loadingStateCell = "_8-4";
export var rowWrapper = "_8-3";
export var standaloneTable = "_8-8";
export var standaloneTableWithBodyFill = "_8-9";
export var stateCell = "_8-5";
export var table = "_8-0";
export var tableBodyFiller = "_8-6";
export var white = "_8-2";